module.exports = __webpack_public_path__ + "static/media/symbols.9940d480.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/picsaos-sprite/svg/symbols.svg
// module id = 455
// module chunks = 1